import DeviceCategory from "common/constants/DeviceCategory";
import { INetwork, INetworkContainer } from "common/store/ProjectStore";

export const getNetworkAntennaName = (network: INetwork, lookupCategory: (deviceID: number) => number, defaultName: string) => {
  const networkAntenna = network.deviceInstances.find(
    (instance) => lookupCategory(instance.deviceID) === DeviceCategory.Antenna,
  );
  if (networkAntenna && networkAntenna.deviceTag) {
    return networkAntenna.deviceTag;
  } else {
    return defaultName;
  }
};

export const getNetwork = (networkID: number, networkContainters: INetworkContainer[]): INetwork | undefined => {
  const networks = networkContainters.flatMap((container) => container.networks);
  return networks.find((network) => network.networkID === networkID);
};

export const getAllNetworks = (networkContainters: INetworkContainer[]): INetwork[] => {
  return networkContainters.flatMap((container) => container.networks);
};
